import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-background py-20" aria-labelledby="faq-title" data-id="element-48" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-49" data-mp="1ccdputophswb">
        <SectionHeading id="faq-title" data-id="element-50" data-mp="2a2i9oe4gvsna">Frequently Asked <span className="text-primary" data-id="element-51" data-mp="2a05v8axx40ez">Questions</span></SectionHeading>
        <div className="mt-10 divide-y divide-border overflow-hidden rounded-xl border border-border bg-background" data-id="element-52" data-mp="254gqzuaydvcc">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} data-id="element-53" data-mp="1v72ci08lbgmo" data-mpi={index}>
                <h3 className="font-sans" data-id="element-54" data-mp="opfa5y8euozg">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-4 text-left font-semibold text-foreground transition-colors duration-150 ease-out hover:bg-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-55" data-mp="oq75r920cmpq">
                    <span data-id="element-56" data-mp="1aoiws6g64f3p">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-muted transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-57" data-mp="1arwx7959ue8i" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-58" data-mp="16np6j6f96o7n">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-59" data-mp="16pa2n0h7uf7m">
                      <p className="px-5 pb-5 leading-relaxed text-muted sm:px-6" data-id="element-60" data-mp="n22p14vwddul">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}